export default "__VITE_ASSET__DsqCqVBc__"